import axiosInstance from './axiosInstance';

const InvoiceStyleService = {
    getStyle: () => axiosInstance.get('/api/invoice-style'),
    saveStyle: (dto) => axiosInstance.put('/api/invoice-style', dto),
    resetStyle: () => axiosInstance.delete('/api/invoice-style'),
    extractFromPdf: (file) => {
        const form = new FormData();
        form.append('file', file);
        return axiosInstance.post('/api/invoice-style/extract', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};

export default InvoiceStyleService;
